import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-cri',
  templateUrl: './header-cri.component.html',
  styleUrls: ['./header-cri.component.css']
})
export class HeaderCRIComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit(): void {
  }

}
